import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const SimilarContainer = ({ children, testId, marginRight, }) => (_jsx(Box, { id: "similarListings", testId: testId, display: "flex", overflow: "hidden", marginRight: marginRight, paddingRight: {
        "breakpoint.base": "spacing.4",
        "breakpoint.xs": "spacing.8",
        "breakpoint.md": "spacing.8",
        "breakpoint.lg": "spacing.4",
        "breakpoint.xl": "spacing.4",
    }, paddingTop: "spacing.6", justifyContent: "flex-start", children: children }));
